import { Component, State, h, ComponentInterface, Prop } from "@stencil/core";
import { AppHomeTest, AppHomeType } from './app-home-types';

@Component({
  tag: 'app-home',
  styleUrl: 'app-home.css',
  shadow: false,
})
export class AppHome implements ComponentInterface {
  @Prop() firmType: AppHomeType;
  @Prop() test?: AppHomeTest;

  contentEl: HTMLIonContentElement;
  slideShowEl: HTMLIonSlidesElement;
  @State() slideShowIsStart: boolean = true;
  @State() slideShowIsEnd: boolean = false;
  @State() slide1NovoAnimationOn: number = 0;
  @State() slide2SmsAnimationOn: boolean = false;
  @State() slide3AnimationOn: number = 1;
  @State() slide4AnimationOn: number = 1;

  defaultAnimationTimer;
  flippyAnimationTimer: any;
  slideshowDelay = 9 * 1000;
  defaultAnimationDuration: number;

  componentWillLoad() {
  }

  componentDidLoad() {
    // this.configureSmoothScroll(this.contentEl);
    // this.defaultAnimationTimeLoop();
  }

  disconnectedCallback() {
    if (this.defaultAnimationTimer) {
      clearTimeout(this.defaultAnimationTimer.clock);
    }
  }

  configureScroll(el: HTMLIonContentElement) {
    this.contentEl = el;
  }
  configureSmoothScroll(el: HTMLIonContentElement) {
    if (el && el.shadowRoot) {
      const scrollDiv = el.shadowRoot.querySelector(".scroll-y") as HTMLDivElement;
      if (scrollDiv) {
        // scrollDiv?.style?.setProperty("scroll-behavior", "smooth");
      }
    }
  }

  render() {
    return (
      <app-sidenav>
        <ion-content ref={el => this.configureScroll(el as HTMLIonContentElement)}>
          <app-landing firmType={this.firmType}></app-landing>

          <app-firm-types firmType={this.firmType}></app-firm-types>

          <app-intro-video></app-intro-video>

          <app-prices></app-prices>

          {/* <app-clients></app-clients> */}

          <app-features></app-features>

          <div id="contact" class="block-container contact-container">
            <div class="contact-block">
              <ion-text>
                <h2 class="center-title">Contato</h2>
              </ion-text>
              <p class="contact-text">
                Ligue ou envie whatsapp para
                <strong>
                  <a href="https://api.whatsapp.com/send/?phone=5518998015281&text=Ol%C3%A1%2C+ví+o+site+Pager+Online+e+tenho+uma+d%C3%BAvida&app_absent=0" target="_blank" rel="noopener noreferrer">
                    <ion-text color="dark"> <ion-icon class="ion-margin-left" name="logo-whatsapp" color="success" /> {"(18) 99801-5281 "}</ion-text>
                  </a>
                </strong>
                para tirar dúvidas ou fazer um orçamento sem compromisso!
              </p>
              <a href="https://api.whatsapp.com/send/?phone=5518998015281&text=Ol%C3%A1%2C+ví+o+site+Pager+Online+e+tenho+uma+d%C3%BAvida&app_absent=0" target="_blank" rel="noopener noreferrer">
                <ion-button color="success" class="ion-margin">
                  <ion-icon name="logo-whatsapp" slot="start"></ion-icon>
                  <ion-text class="ion-margin-start">Conversar no Whatsapp</ion-text>
                </ion-button>
              </a>
              {/* <a href="https://www.instagram.com/onlinepager/" target="_blank" rel="noopener noreferrer">
                <ion-button color="light" class="contact-facebook-button ion-margin">
                  <ion-icon color="danger" name="logo-instagram" slot="start"></ion-icon>
                  <ion-text color="dark" class="ion-margin-start">Siga no Instagram</ion-text>
                </ion-button>
              </a>
              <a href="https://www.facebook.com/Pager-Online-App-100482565674149/" target="_blank" rel="noopener noreferrer">
                <ion-button color="light" class="contact-facebook-button ion-margin">
                  <ion-icon color="primary" name="logo-facebook" slot="start"></ion-icon>
                  <ion-text color="dark" class="ion-margin-start">Curta no Facebook</ion-text>
                </ion-button>
              </a> */}
            </div>
            {/* <a href="assets/docs/pager-privacy.docx" download="pager-privacy.docx"></a> */}
            <ion-router-link color="dark" style={{'text-decoration': 'underline'}} href="/privacy">Política de privacidade</ion-router-link>
          </div>
          <ion-fab vertical="bottom" horizontal="end" slot="fixed">
            <ion-fab-button color="success" onClick={() => window.open("https://api.whatsapp.com/send/?phone=5518998015281&text=Ol%C3%A1%2C+ví+o+site+Pager+Online+e+tenho+uma+d%C3%BAvida&app_absent=0")}>
              <ion-icon name="logo-whatsapp" size="large"></ion-icon>
            </ion-fab-button>
          </ion-fab>
        </ion-content>


      </app-sidenav>
    );
  }
}
